// ============================================================================
// GOLD RATE SERVICE
// ============================================================================

import { get, post, put, patch, del } from '../client/axiosClient';
import { goldRateEndpoints } from '../endpoints/goldRates.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  PaginatedResponse,
  EmptyResponse,
  ID,
} from '../types';
import { transformPaginatedResponse } from '../types/common.types';
import type {
  GoldRate,
  CreateGoldRateRequest,
  UpdateGoldRateRequest,
  GoldRateFilterParams,
} from '../types/goldRates.types';

class GoldRateService {
  async getAll(params?: GoldRateFilterParams): Promise<PaginatedResponse<GoldRate>> {
    const endpoint = params
      ? buildEndpointWithQuery(goldRateEndpoints.list(), params)
      : goldRateEndpoints.list();
    const response = await get(endpoint);
    return transformPaginatedResponse<GoldRate>(response.data);
  }

  async getById(id: ID): Promise<ApiResponse<GoldRate>> {
    const response = await get<ApiResponse<GoldRate>>(goldRateEndpoints.getById(id));
    return response.data;
  }

  async getActive(): Promise<ApiResponse<GoldRate>> {
    const response = await get<ApiResponse<GoldRate>>(goldRateEndpoints.active());
    return response.data;
  }

  async create(data: CreateGoldRateRequest): Promise<ApiResponse<GoldRate>> {
    const response = await post<ApiResponse<GoldRate>>(goldRateEndpoints.create(), data);
    return response.data;
  }

  async update(id: ID, data: UpdateGoldRateRequest): Promise<ApiResponse<GoldRate>> {
    const response = await put<ApiResponse<GoldRate>>(goldRateEndpoints.update(id), data);
    return response.data;
  }

  async activate(id: ID): Promise<ApiResponse<GoldRate>> {
    const response = await patch<ApiResponse<GoldRate>>(goldRateEndpoints.activate(id), {});
    return response.data;
  }

  async delete(id: ID): Promise<EmptyResponse> {
    const response = await del<EmptyResponse>(goldRateEndpoints.delete(id));
    return response.data;
  }
}

export const goldRateService = new GoldRateService();
export default goldRateService;
